import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getBeneficiaryBankData} from '../../services/getBeneficiaryBankData';

export function useGetBeneficiaryBankDataQuery() {
	return useQuery({
		queryKey: [QUERY_KEYS.BENEFICIARY_BANK_DATA],
		queryFn: async ({signal}) => getBeneficiaryBankData({signal}),
		retry: 2,
	});
}
